import { createAction, props } from '@ngrx/store';
import { CredentialingPermissions } from 'src/app/credentialing/models/credentialing-permissions.model';
import { AutoAssignSettingChange } from 'src/app/credentialing/working-list/models/auto-assign-setting-change.model';
import { AutoAssignType } from 'src/app/credentialing/working-list/models/auto-assign-type.model';
import { ActiveAutoAssignType } from 'src/app/credentialing/auto-assign/models/auto-assign-type.model';
import { NotificationSettingChange } from 'src/app/credentialing/working-list/models/notification-setting-change.model';
import { NotificationType } from 'src/app/credentialing/working-list/models/notification-type.model';
import { Agency } from 'src/app/credentialing/auto-assign/models/agency.model';
import { CredentialingSpecialist } from 'src/app/credentialing/auto-assign/models/credentialing-specialist.model';
import { PayloadAgency } from 'src/app/credentialing/auto-assign/models/payload-agency.model';
import { Recruiter } from 'src/app/credentialing/auto-assign/models/recriuter.model';
import { TravelCredentialingSpecialist } from 'src/app/credentialing/auto-assign/models/travel-credentialing-specialist.model';
import { PayloadTravel } from 'src/app/credentialing/auto-assign/models/payload-travel.model';
import { AdminCredentialingSpecialist } from 'src/app/credentialing/auto-assign/models/admin-credentialing-specialist.model';
import { PerDiemAssignmentRules } from 'src/app/credentialing/auto-assign/models/per-diem-assignment-rules.model';
import { PerDiemSpecialist } from 'src/app/credentialing/auto-assign/models/per-diem-specialist.model';
import { UserAssignmentChange } from 'src/app/shared/models/user-assignment-change-request.model';
import { KeyValue } from '@angular/common';

export const loadAutoAssignSettings = createAction(
    '[ADMIN SYSTEM SETTINGS COMPONENT] Load Auto Assign Settings',
    props<{ settingIds: number[] }>()
);
export const loadAutoAssignSettingsSuccess = createAction(
    '[ADMIN SYSTEM SETTINGS API] Load Auto Assign Settings Success',
    props<{ settings: AutoAssignType[] }>()
);
export const loadAutoAssignSettingsFailure = createAction(
    '[ADMIN SYSTEM SETTINGS API] Load Auto Assign Settings Failure',
    props<{ error: unknown }>()
);

export const updateAutoAssignSettings = createAction(
    '[ADMIN SYSTEM SETTINGS COMPONENT] Update Auto Assign Setting',
    props<{ settings: AutoAssignSettingChange }>()
);
export const updateAutoAssignSettingsSuccess = createAction(
    '[ADMIN SYSTEM SETTINGS API] Update Auto Assign Setting Success'
);
export const updateAutoAssignSettingsFailure = createAction(
    '[ADMIN SYSTEM SETTINGS API] Update Auto Assign Setting Failure',
    props<{ error: unknown }>()
);

export const loadNotificationCategory = createAction(
    '[ADMIN SYSTEM SETTINGS COMPONENT] Load Notification Category',
    props<{ categoryId: number }>()
);
export const loadNotificationCategorySuccess = createAction(
    '[ADMIN SYSTEM SETTINGS API] Load Notification Category Success',
    props<{ notification: NotificationType }>()
);
export const loadNotificationCategoryFailure = createAction(
    '[ADMIN SYSTEM SETTINGS API] Load Notification Category Failure',
    props<{ error: unknown }>()
);

export const updateNotificationCategory = createAction(
    '[ADMIN SYSTEM SETTINGS COMPONENT] Update Notification Category',
    props<{ update: NotificationSettingChange }>()
);
export const updateNotificationCategorySuccess = createAction(
    '[ADMIN SYSTEM SETTINGS API] Update Notification Category Success',
    props<{ categoryId: number }>()
);
export const updateNotificationCategoryFailure = createAction(
    '[ADMIN SYSTEM SETTINGS API] Update Notification Category Failure',
    props<{ error: unknown }>()
);

export const loadCredentialingPermissions = createAction(
    '[CREDENTIALING PREMISSIONS API] Load Credentialing Permissions'
);
export const loadCredentialingPermissionsSuccess = createAction(
    '[CREDENTIALING PREMISSIONS API] Load Credentialing Permissions Success',
    props<{ permissions: CredentialingPermissions }>()
);
export const loadCredentialingPermissionsFailure = createAction(
    '[CREDENTIALING PREMISSIONS API] Load Credentialing Permissions Failure',
    props<{ error: unknown }>()
);

export const loadAgencies = createAction('[AUTO ASSIGN AGENCY COMPONENT] Load Agencies');
export const loadAgenciesSuccess = createAction(
    '[AUTO ASSIGN AGENCY API] Load Agencies Success',
    props<{ agencies: Agency[] }>()
);
export const loadAgenciesFailure = createAction(
    '[AUTO ASSIGN AGENCY API] Load Agencies Failure',
    props<{ error: unknown }>()
);

export const loadCredentialingSpecialists = createAction(
    '[AUTO ASSIGN AGENCY COMPONENT] Load Credentialing Specialists'
);
export const loadCredentialingSpecialistsSuccess = createAction(
    '[AUTO ASSIGN AGENCY API] Load Credentialing Specialists Success',
    props<{ credentialingSpecialists: CredentialingSpecialist[] }>()
);
export const loadCredentialingSpecialistsFailure = createAction(
    '[AUTO ASSIGN AGENCY API] Load Credentialing Specialists Failure',
    props<{ error: unknown }>()
);

export const updateCredentialSpecialists = createAction(
    '[AUTO ASSIGN AGENCY COMPONENT] Update Credentialing Specialists',
    props<{ payload: PayloadAgency[] }>()
);
export const updateCredentialSpecialistsSuccess = createAction(
    '[AUTO ASSIGN AGENCY API] Update Credentialing Specialists Success'
);
export const updateCredentialSpecialistsFailure = createAction(
    '[AUTO ASSIGN AGENCY API] Update Credentialing Specialists Failure',
    props<{ error: unknown }>()
);

export const loadRecruiters = createAction('[AUTO ASSIGN TRAVEL COMPONENT] Load Recruiters');
export const loadRecruitersSuccess = createAction(
    '[AUTO ASSIGN TRAVEL API] Load Recruiters Success',
    props<{ recruiters: Recruiter[] }>()
);
export const loadRecruitersFailure = createAction(
    '[AUTO ASSIGN TRAVEL API] Load Recruiters Failure',
    props<{ error: unknown }>()
);

export const loadTravelSpecialists = createAction(
    '[AUTO ASSIGN TRAVEL COMPONENT] Load Travel Credentialing Specialists'
);
export const loadTravelSpecialistsSuccess = createAction(
    '[AUTO TRAVEL AGENCY API] Load Travel Credentialing Specialists Success',
    props<{ travelCredentialingSpecialists: TravelCredentialingSpecialist[] }>()
);
export const loadTravelSpecialistsFailure = createAction(
    '[AUTO TRAVEL AGENCY API] Load Travel Credentialing Specialists Failure',
    props<{ error: unknown }>()
);

export const updateCredentialTravelSpecialists = createAction(
    '[AUTO ASSIGN TRAVEL COMPONENT] Update Travel Credentialing Specialists',
    props<{ payload: PayloadTravel[] }>()
);
export const updateCredentialTravelSpecialistsSuccess = createAction(
    '[AUTO ASSIGN TRAVEL API] Update Travel Credentialing Specialists Success'
);
export const updateCredentialTravelSpecialistsFailure = createAction(
    '[AUTO ASSIGN TRAVEL API] Update Travel Credentialing Specialists Failure',
    props<{ error: unknown }>()
);

export const loadTypes = createAction('[AUTO ASSIGN ADMIN COMPONENT] Load Types');
export const loadTypesSuccess = createAction(
    '[AUTO ASSIGN ADMIN API] Load Types Success',
    props<{ types: ActiveAutoAssignType[] }>()
);
export const loadTypesFailure = createAction('[AUTO ASSIGN ADMIN API] Load Types Failure', props<{ error: unknown }>());

export const loadSpecialists = createAction('[AUTO ASSIGN ADMIN COMPONENT] Load Credentialing Specialist');
export const loadSpecialistsSuccess = createAction(
    '[AUTO ASSIGN ADMIN API] Load Credentialing Specialist Success',
    props<{ adminSpecialists: AdminCredentialingSpecialist[] }>()
);
export const loadSpecialistsFailure = createAction(
    '[AUTO ASSIGN ADMIN API] Load Credentialing Specialist Failure',
    props<{ error: unknown }>()
);

export const updateSpecialists = createAction(
    '[AUTO ASSIGN ADMIN COMPONENT] Update Admin Specialist',
    props<{ adminSpecialists: AdminCredentialingSpecialist[] }>()
);
export const updateSpecialistsSuccess = createAction('[AUTO ASSIGN ADMIN API] Update Admin Specialist Success');
export const updateSpecialistsFailure = createAction(
    '[AUTO ASSIGN ADMIN API] Update Admin Specialist Failure',
    props<{ error: unknown }>()
);

export const loadPerDiemRules = createAction('[AUTO ASSIGN PER-DIEM COMPONENT] Load Rules');
export const loadPerDiemRulesSuccess = createAction(
    '[AUTO ASSIGN PER-DIEM API] Load Rules Success',
    props<{ perDiemRules: PerDiemAssignmentRules[] }>()
);
export const loadPerDiemRulesFailure = createAction(
    '[AUTO ASSIGN PER-DIEM API] Load Rules Failure',
    props<{ error: unknown }>()
);

export const loadPerDiemSpecialists = createAction('[AUTO ASSIGN PER-DIEM COMPONENT] Load Specialists');
export const loadPerDiemSpecialistsSuccess = createAction(
    '[AUTO ASSIGN PER-DIEM API] Load Specialists Success',
    props<{ perDiemSpecialists: PerDiemSpecialist[] }>()
);
export const loadPerDiemSpecialistsFailure = createAction(
    '[AUTO ASSIGN PER-DIEM API] Load Specialists Failure',
    props<{ error: unknown }>()
);

export const updatePerDiemRules = createAction(
    '[AUTO ASSIGN PER-DIEM COMPONENT] Update Rules',
    props<{ perDiemRules: PerDiemAssignmentRules[] }>()
);
export const updatePerDiemRulesSuccess = createAction('[AUTO ASSIGN PER-DIEM API] Update Rules Success');
export const updatePerDiemRulesFailure = createAction(
    '[AUTO ASSIGN PER-DIEM API] Update Rules Failure',
    props<{ error: unknown }>()
);

export const updateCredentialingSpecialistFromCandidatesGrid = createAction(
    '[CANDIDATES GRID] Update Credentialing Specialist',
    props<{ candidateId: number; assignmentChange: UserAssignmentChange }>()
);
export const updateCredentialingSpecialistFromCandidatesGridSuccess = createAction(
    '[CANDIDATES GRID] Update Credentialing Specialist success',
    props<{ updatedGridItem: KeyValue<string, unknown>[] }>()
);
export const updateCredentialingSpecialistFromCandidatesGridFailure = createAction(
    '[CANDIDATES GRID] Update Credentialing Specialist failure',
    props<{ error: unknown }>()
);
